//*****共用的method工具*****

import { defaultFormat, GetHistory } from "./BasicData";
import moment from "moment-taiwan";
import * as React from "react";
import { getGlobalServerConfig } from "../Route/RootMiddleware";
import CacheLoader from "./CacheLoader";
import { screen } from "@testing-library/react";
import { menuIcons } from "../Basic/BasicData";
import { SetStorageData } from "./CommonService";

export const IsNullOrEmpty = (object) => {
  if (object === null || object === undefined) return true;
  if (typeof object === "string" && object === "") return true;
  if (typeof object === "object" && JSON.stringify(object) === "[]")
    return true;
  return false;
};

//為陣列資料加上No欄位供Grid顯示
//data:陣列資料
//page?:頁數  ps:從0開始
//pageSize?:每頁筆數
export const AddNoColumn = (data, page = 0, pageSize = 0) => {
  if (!Array.isArray(data) || data.length === 0) return data;

  if (data[0].hasOwnProperty("NO")) return data;

  let No = 1;
  No += page * pageSize;
  data.forEach((dataItem) => {
    Object.defineProperty(dataItem, "NO", {
      value: No++,
      writable: true, //可寫
      enumerable: true, //可被列舉出
    });
  });
  return data;
};

export const HtmlDecode = (text) => {
  // return text;
  // text = text.replace(/<p>/gi, '＜p＞');
  // text = text.replace(/<\/p>/gi, '＜／p＞');
  // text = text.replace(/<br>/gi, '＜br＞');
  // text = text.replace(/<br\/>/gi, '＜br／＞');
  let temp = document.createElement("div");
  temp.innerHTML = text;
  let output = temp.innerText || temp.textContent;
  temp = null;
  // output = output.replace(/＜p＞/gi, '<p>');
  // output = output.replace(/＜／p＞/gi, '</p>');
  // output = output.replace(/＜br＞/gi, '<br>');
  // output = output.replace(/＜br／＞/gi, '<br>');
  return output;
};

export const SetMaskOnOff = async (flag) => {
  let overlay = document.getElementById("globalOverlay");
  if (overlay !== null) {
    overlay.className = flag ? "fullscreen" : "hide fullscreen";
  }
  if (flag) {
    // 移除目前按鈕的焦點，防止 Enter 重複觸發
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

  }
};

export const FormatDate = (date, format = defaultFormat) => {
  /* 常用日期格式:
        YYYY-MM-DD      e.g. 2020-09-10
        YYYY/MM/DD HH:mm:ss     e.g. 2020/09/10 10:11:11
        tYY/MM/DD       e.g. 109/09/10
        tYY年MM月DD日     e.g. 109年09月10日
        MM月DD日 tYY年    e.g. 09月10日 109年
    */
  if (IsNullOrEmpty(date)) return null;
  return moment(date).format(format);
};

//機關選單資料轉換(取得Org object value)
export const GetOrgValue = (data) => {
  let value = [];
  data.map((item) => {
    value.push(item.ORG_ID);
    return value;
  });
  return value;
};

export const IsFunction = (functionToCheck) => {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
};

/**
 * 紀錄TabData的暫存行為，以供增刪修時使用
 * @param {*} editedData 傳入useRef以進行記錄， 空的data /Tab切換前的 / 載入的暫存
 * @param {*} item 需增刪的資料 ，   新增加的 /當前Tab的 /需增刪的資料
 * @param {string} hiddenIndex 供新增資料判定的欄位名  
 * @param {string} SEQ 供舊資料判定的欄位名 
 * @param {string} parentIndex 供陣列中的陣列判斷相互關係的欄位名，若無傳入則為undefined
 */
export const handleEditedGridData = (editedData, item, hiddenIndex, SEQ, parentIndex) => {
  let hasChange = false;

  //如果是新資料
  if (item[hiddenIndex] != null && item.editType === 1) {
    //新增tab後已經修改過(進入editedData)又再次修改，則將新的覆蓋editedData的那一筆
    if (parentIndex === undefined) {
      if (editedData.current.some(ei => ei[hiddenIndex] === item[hiddenIndex])) {
        let newItems = editedData.current.map(ei => ei[hiddenIndex] === item[hiddenIndex] ? item : ei);
        editedData.current = newItems;
        hasChange = true;
      } else {//新增後第一次修改，將其加入異動過的資料(editedData)
        editedData.current.push(item);
        hasChange = true;
      }
    }
    // 若有parentIndex，需多判斷parentIndex是否相同
    else {
      if (editedData.current.some(ei => (ei[hiddenIndex] === item[hiddenIndex] && ei[parentIndex] === item[parentIndex]))) {
        let newItems = editedData.current.map(ei => (ei[hiddenIndex] === item[hiddenIndex] && ei[parentIndex] === item[parentIndex]) ? item : ei);
        editedData.current = newItems;
        hasChange = true;
      } else {//新增後第一次修改，將其加入異動過的資料(editedData)
        editedData.current.push(item);
        hasChange = true;
      }
    }
  } else if (item.editType === 2) {//更新舊資料
    //舊資料已修改過(進入editedData)又再次修改，則將修改的覆蓋editedData的那一筆
    if (editedData.current.some(ei => ei[SEQ] === item[SEQ])) {
      let newItems = editedData.current.map(ei => ei[SEQ] === item[SEQ] ? item : ei);
      editedData.current = newItems;
      hasChange = true;
    }
    else {//舊資料第一次修改，將其加入異動過的資料
      editedData.current.push(item);
      hasChange = true;
    }
  } else if (item.editType === 3) {//刪除
    //移除異動過(已在editedData)且為舊資料有的tab(有SEQ)
    if (editedData.current.some(ei => ei[SEQ] === item[SEQ] && item[SEQ] !== 0)) {
      //將item.state該成remove
      let newItems = editedData.current.map(ei => ei[SEQ] === item[SEQ] ? item : ei);
      editedData.current = newItems;
      hasChange = true;
    }
    if (parentIndex === undefined) {
      //移除異動過(已在editedData)且為後來新增的tab(有hiddenIndex) 
      if (editedData.current.some(ei => ei[hiddenIndex] === item[hiddenIndex] && item[SEQ] === 0)) {

        let index = editedData.current.findIndex(record => record[hiddenIndex] === item[hiddenIndex]);
        editedData.current.splice(index, 1);
        hasChange = true;
      } else { //移除沒有異動過且為舊資料有的tab(有SEQ)(沒有hiddenIndex)
        if (!item[hiddenIndex] || item[hiddenIndex] > 0)
          editedData.current.push(item);
        hasChange = true;
      }
    }
    // 若有parentIndex，需多判斷parentIndex是否相同
    else {
      //移除異動過(已在editedData)且為後來新增的tab(有hiddenIndex) 
      if (editedData.current.some(ei => ei[hiddenIndex] === item[hiddenIndex] && item[SEQ] === 0 && ei[parentIndex] === item[parentIndex])) {

        let index = editedData.current.findIndex(record => (record[hiddenIndex] === item[hiddenIndex] && record[parentIndex] === item[parentIndex]));
        editedData.current.splice(index, 1);
        hasChange = true;
      } else { //移除沒有異動過且為舊資料有的tab(有SEQ)(沒有hiddenIndex)
        if (!item[hiddenIndex])
          editedData.current.push(item);
        hasChange = true;
      }
    }
  }


  return hasChange;
}

/**
 * 民國年日期驗證規則
 */
export const twDateRegex = new RegExp(
  /^([0-9]{2}|[0-9]{3})\/(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])$/
); //ex:110/06/13

/**
 * 連絡電話驗證規則:
 * 1.(2~4碼)1~4碼-4碼
 * 2.(2~4碼)1~4碼-4碼#分機
 */
// export const telRegex = /\(\d{2,4}\)(?:(?=\d{1,4}-\d{4}#)\d{1,4}-\d{4}#\d+$|\d{1,4}-\d{4}$)/g;

/**
 * 連絡電話驗證規則:
 * 只允許數字、括號及#
 */
export const telRegex = /^[0-9\#\(\)\/]+$/g;

/**
 * 手機驗證規則:
 * 10碼
 */
export const mobileRegex = /\d{10}$/;

/**
 * 統一編號檢查
 * @param {String} regNo 統一編號
 * @returns true:符合 false:不符合
 */
export const regNoVerify = (regNo) => {
  // 統一編號數量
  let count = 8;
  // 邏輯乘數
  let multiplier = [1, 2, 1, 2, 1, 2, 4, 1];
  // 最後整除值
  let lastDivisibleVal = 5;

  // 非數字 or 不是8碼 都是錯誤
  if (isNaN(parseInt(regNo)) || regNo.length !== count) {
    return false;
  }

  let result;
  if (parseInt(regNo.charAt(6)) === 7) {
    // 統一編號第7位數為"7"
    result = seventhIsSeven(regNo, count, multiplier, lastDivisibleVal);
  } else {
    // 統一編號第7位數非"7"
    result = seventhIsNotSeven(regNo, count, multiplier, lastDivisibleVal);
  }

  return result;
};

/**
 * 第7位數為"7"
 * @param {*} regNo 統一編號
 * @param {*} count 統一編號數量
 * @param {*} multiplier 邏輯乘數
 * @param {*} lastDivisibleVal 最後整除值
 * @returns
 */
const seventhIsSeven = (regNo, count, multiplier, lastDivisibleVal) => {
  let total1 = 0;
  let total2 = 0;

  for (let i = 0; i < count; i++) {
    if (i === 6) {
      total1 += 1;
      total2 += 0;
    } else {
      let val = parseInt(regNo.charAt(i)) * multiplier[i];
      let valStr = val.toString();
      if (valStr.length > 1) {
        for (let j = 0; j < valStr.length; j++) {
          total1 += parseInt(valStr.charAt(j));
          total2 += parseInt(valStr.charAt(j));
        }
      } else {
        total1 += val;
        total2 += val;
      }
    }
  }
  return total1 % lastDivisibleVal === 0 || total2 % lastDivisibleVal === 0;
};

/**
 * 第7位數非"7"
 * @param {*} regNo 統一編號
 * @param {*} count 統一編號數量
 * @param {*} multiplier 邏輯乘數
 * @param {*} lastDivisibleVal 最後整除值
 * @returns
 */
const seventhIsNotSeven = (regNo, count, multiplier, lastDivisibleVal) => {
  let total = 0;
  for (let i = 0; i < count; i++) {
    let val = parseInt(regNo.charAt(i)) * multiplier[i];
    let valStr = val.toString();
    if (valStr.length > 1) {
      for (let j = 0; j < valStr.length; j++) {
        total += parseInt(valStr.charAt(j));
      }
    } else {
      total += val;
    }
  }

  return total % lastDivisibleVal === 0;
};

export const logOut = async () => {
  //清除BasicData
  getGlobalServerConfig().BasicData.token.set("");
  getGlobalServerConfig().BasicData.userId.set("");
  getGlobalServerConfig().BasicData.email.set("");
  getGlobalServerConfig().BasicData.orgId.set("");
  getGlobalServerConfig().BasicData.roles.set([]);
  //清除快取
  await CacheLoader().DeleteCache();
  //導頁導到登入頁面
  GetHistory().push("/");

  getGlobalServerConfig().BasicData.isCompDone.set("");
};

/**
 * 設定Menu清單
 * @param {*} functionList
 * @returns
 */
export const setMenu = (functionList) => {
  return functionList.map((o) => {
    //設定menu第一層icon跟className
    o.className = menuIcons.key;
    o.imageUrl = menuIcons.value;

    if (o.children?.length == 0 && o.function_url !== "") o.children = null;

    return { ...o };
  });
};

/**
 * 開啟新視窗
 * @param {*} url
 * @param {*} name
 * @param {*} title 新視窗頁籤名稱
 * @param {*} ispopup 是否為開新視窗，否則為開 tab
 * @param {*} w 開窗寬度
 * @param {*} h 開窗高度
 */
export const openPage = (
  url,
  name = "_blank",
  title = "",
  ispopup = false,
  w = 0,
  h = 0
) => {
  let popupSize = "";
  if (ispopup) {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    popupSize = `width=${w / systemZoom}, 
                    height=${h / systemZoom}, 
                    top=${top}, 
                    left=${left}`;
  }

  const newWindow = window.open(url, name, popupSize);

  if (!IsNullOrEmpty(title)) {
    // 更換新分頁title
    newWindow.onunload = () => {
      setTimeout(() => {
        newWindow.document.title = title;
      }, 200);
    };
  }

  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }
};

/**
 * 開啟章節視窗
 * @param {*} url
 * @param {*} name
 * @param {*} title 新視窗頁籤名稱
 */
export const openChapterPage = (url, name, title, storageData) => {
  const newWindow = window.open(url, name, "");

  if (storageData != null) {
    SetStorageData(storageData, "chapterInfo", newWindow);
  }

  if (!IsNullOrEmpty(title)) {
    // 更換新分頁title
    newWindow.onunload = () => {
      setTimeout(() => {
        newWindow.document.title = title;
      }, 200);
    };
  }

  if (window.focus) {
    newWindow.focus();
  }
};

/**
 * 關閉此頁並回到來源頁
 * 為處理弱掃Client DOM Open Redirect問題有調整寫法
 * 原寫法為:
 * export const closeAndbackToParentWindow = (window) => {
    window.opener.name = 'parentWin';
    window.open(window.opener.location.href, window.opener.name);
    window.opener.focus();
    window.close()
    }
 * @param {*} window 傳入視窗
 */
export const closeAndbackToParentWindow = (window) => {
  // 關閉視窗
  window.close();

  // 如果有來源頁面，返回到來源頁面
  if (window.opener) {
    window.opener.name = "parentWin";
    window.opener.focus();
  }
};

/**
 * 判斷是否排除自動轉大寫
 * @param {string} type 
 * @param {string} name 
 * @param {string} id 
 * @returns 
 */
export const isExcludedFromUppercase = (type, name, id) => {
  // i 旗標代表不區分大小寫 (Case-insensitive)
  const excludeRegex = /email|captcha|user_pd|case_pd|check_case_pwd|user_id/i;

  const _type = (type || "").toLowerCase();
  const _name = (name || "").toLowerCase();
  const _id = (id || "").toLowerCase();

  return (
    _type === "password" ||
    excludeRegex.test(_name) ||
    excludeRegex.test(_id)
  );
};

export const formatNumberWithCommas = (value, decimals = 2) =>{
    // 檢查數值是否為 null 或 undefined
    if (value === null || value === undefined) {
        return "";
    }

    // 將輸入轉為字串並移除可能已存在的千分位逗號
    const cleanString = String(value).replace(/,/g, '').trim();

    // 檢查移除逗號後是否為合法數字（排除空字串與 NaN）
    if (cleanString === "" || isNaN(Number(cleanString))) {
        return value; // 無法轉為數字，回傳原本的輸入
    }

    const numberValue = Number(cleanString);

    // 使用 Intl.NumberFormat 進行千分位與固定小數位數處理
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(numberValue);
}
/**比對兩字串是否相符
 * @description
 * 去除所有空白並統一轉大寫進行比對
 * (因為目前專案英文輸入框會自動轉大寫)
 */
export const isMatch = (str1, str2) => {
    const format = (s) => (s || '').replace(/\s+/g, '').toUpperCase();
    return format(str1) === format(str2);
};
